import React from 'react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { appRoutes } from 'selfServicePortal/constants/routes'
import { userManager } from '../../../auth/services/auth.service'

function LogoutCallbackPage() {
	const { t } = useTranslation()
	let link: string = appRoutes.login

	useEffect(() => {
		let origin = window.location.origin.toLowerCase()
		if (origin.includes('meineaktivierung.tfbank.de')) {
			// eslint-disable-next-line
			link = appRoutes.cardApplicationLogin
		}
	}, [])

	useEffect(() => {
		userManager.signoutRedirectCallback().then(() => {
			sessionStorage.clear()
		})
		userManager.clearStaleState()
	}, [])

	return (
		<div className="h-100 login-bg">
			<div className="h-100 inner d-flex justify-content-center align-items-center w-100">
				<div className="logged-out d-flex flex-column align-items-center container text-center">
					<div className="my-4">{t('LoggedOut')}</div>
					<Link to={link} className="btn btn-primary">
						{t('Login')}
					</Link>
				</div>
			</div>
		</div>
	)
}

export default LogoutCallbackPage
